"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function($q) {
  var that = this;
  var rediWindows = {};

  that.clearAllWindows = function() {
    _.forOwn(rediWindows, function(windowList, type) {
      if (!isAlwaysOpenType(windowList)) {
        rediWindows[type] = [];
      }
    });
  };

  that.getAllWindows = function() {
    return _.flattenDeep(_.values(rediWindows));
  };

  that.getWindowsByType = function(windowType) {
    if (rediWindows.hasOwnProperty(windowType)) {
      return rediWindows[windowType];
    }
    return [];
  };

  function isAlwaysOpenType(windowList) {
    return _.some(windowList, "isAlwaysOpen");
  }

  that.addWindow = function(rediWindow) {
    if (!rediWindows.hasOwnProperty(rediWindow.getType())) {
      rediWindows[rediWindow.getType()] = [];
    }
    rediWindows[rediWindow.getType()].push(rediWindow);
  };

  that.removeWindow = function(rediWindow) {
    _.remove(rediWindows[rediWindow.getType()], function(obj) {
      return obj.getInstanceName() === rediWindow.getInstanceName();
    });
  };

  that.getWindowByNativeId = function(nativeId) {
    var allWindowsArray = that.getAllWindows();
    return findRediWindowByNativeId(allWindowsArray, nativeId);
  };

  that.getWindowByInstanceName = function(instanceName) {
    var windows = that.getAllWindows();
    return _.find(windows, function(rediWindow) {
      return instanceName === rediWindow.getInstanceName();
    });
  };

  function findRediWindowByNativeId(rediWindows, nativeId) {
    if (rediWindows.length === 0) {
      return $q.reject();
    } else {
      return isFoundRediWindow(rediWindows.shift(), nativeId).catch(function() {
        return findRediWindowByNativeId(rediWindows, nativeId);
      });
    }
  }

  function isFoundRediWindow(rediWindow, nativeId) {
    return rediWindow.getNativeId().then(function(id) {
      if (_(nativeId).toString() !== _(id).toString()) {
        return $q.reject();
      } else {
        return rediWindow;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/repositories/RediWindowRepository.js